import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const phases = [
  {
    phase: 'Fase 1',
    timing: '30-45 dias antes',
    icon: 'ri-calendar-check-line',
    items: [
      'Defina o objetivo: é palestra única, múltiplas trilhas ou evento multilíngue?',
      'Calcule o número estimado de participantes e canais necessários',
      'Pesquise fornecedores e solicite orçamentos com visita técnica inclusa',
      'Reserve o espaço considerando que um único salão pode comportar múltiplas sessões',
    ],
  },
  {
    phase: 'Fase 2',
    timing: '15-20 dias antes',
    icon: 'ri-settings-3-line',
    items: [
      'Agende a visita técnica do fornecedor ao local para mapear cobertura de sinal',
      'Defina a disposição das áreas de audiência no espaço físico',
      'Alinhe com palestrantes: explique o funcionamento dos fones e agende soundcheck',
      'Planeje a estação de entrega e higienização dos fones na entrada',
    ],
  },
  {
    phase: 'Fase 3',
    timing: '5-7 dias antes',
    icon: 'ri-message-3-line',
    items: [
      'Envie comunicação aos participantes explicando como funciona a palestra silenciosa',
      'Confirme número final de fones com o fornecedor (+10% de backup)',
      'Prepare a sinalização visual: placas indicando canais, instruções nos fones',
      'Alinhe a equipe de apoio: 1 pessoa a cada 100 participantes para orientar na entrada',
    ],
  },
  {
    phase: 'Fase 4',
    timing: 'Dia do evento',
    icon: 'ri-headphone-line',
    items: [
      'Soundcheck com palestrantes 30-60 minutos antes da abertura',
      'Estação de entrega dos fones com higienização visível e orientação individual',
      'Equipe de apoio circulando para ajudar com ajustes de volume e troca de canais',
      'Monitore os canais durante o evento para garantir qualidade de áudio em todos',
    ],
  },
  {
    phase: 'Fase 5',
    timing: 'Pós-evento',
    icon: 'ri-file-chart-line',
    items: [
      'Solicite relatório de distribuição de audiência por canal ao longo do tempo',
      'Colete feedback dos participantes sobre a experiência com os fones',
      'Analise os dados de engajamento para planejar a próxima edição',
      'Compartilhe os resultados com stakeholders: economia, engajamento, satisfação',
    ],
  },
];

export default function ChecklistSection() {
  const { ref: headerRef, isVisible: headerVisible } = useScrollAnimation({ threshold: 0.1 });
  const { ref: phasesRef, isVisible: phasesVisible } = useScrollAnimation({ threshold: 0.05 });

  return (
    <section className="py-20 md:py-32 bg-white">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div ref={headerRef} className="text-center mb-16">
          <span className="font-body text-xs font-semibold uppercase tracking-[0.2em] text-primary mb-4 block">
            Passo a Passo
          </span>
          <h2
            className={`font-heading font-bold text-4xl md:text-6xl text-secondary mb-6 transition-all duration-700 ${headerVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
          >
            planeje seu evento<br />sem esquecer nada
          </h2>
          <p
            className={`font-body text-lg text-gray-500 max-w-xl mx-auto transition-all duration-700 delay-150 ${headerVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
          >
            Um checklist em 5 fases — da contratação ao pós-evento
          </p>
        </div>

        {/* Timeline */}
        <div ref={phasesRef} className="relative">
          {/* Vertical line */}
          <div className="absolute left-6 md:left-8 top-8 bottom-8 w-px bg-gray-200" />

          <div className="space-y-0">
            {phases.map((phase, i) => (
              <div
                key={i}
                className={`relative pl-16 md:pl-20 pb-12 last:pb-0 transition-all duration-500 ${phasesVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
                style={{ transitionDelay: `${i * 100}ms` }}
              >
                {/* Circle on timeline */}
                <div className="absolute left-4 md:left-6 top-2 w-5 h-5 rounded-full bg-primary border-4 border-white z-10" />

                {/* Phase header */}
                <div className="flex flex-wrap items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary/10 flex-shrink-0">
                    <i className={`${phase.icon} text-primary text-lg`} />
                  </div>
                  <div>
                    <span className="font-heading font-bold text-primary text-sm">{phase.phase}</span>
                    <span className="font-body text-xs text-gray-400 ml-3">{phase.timing}</span>
                  </div>
                </div>

                {/* Checklist items */}
                <div className="bg-gray-50 border border-gray-100 rounded-2xl p-5 md:p-6 space-y-3">
                  {phase.items.map((item, j) => (
                    <div key={j} className="flex items-start gap-3">
                      <div className="w-5 h-5 flex items-center justify-center rounded-full bg-primary/15 flex-shrink-0 mt-0.5">
                        <i className="ri-check-line text-primary text-xs" />
                      </div>
                      <p className="font-body text-sm text-gray-700 leading-relaxed">{item}</p>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}